import httpRequest from "@/infra/httpRequest";
import RepositoryInterface from "@/application/repositories/RepositoryInterface";
import PaymentDto from "../dto/PaymentDto";

export default class PaymentRepository implements RepositoryInterface<PaymentDto>{
  public async create(payment: PaymentDto): Promise<PaymentDto> {
    try {
      const { data } = await httpRequest.post('/payment/process/credit_card', {
        ...payment.toJson(),
      });

      payment.paymentId = data.payment.payment_id

      return payment;
    } catch (err: any) {
      const { response: { data: { error } } } = err;
      throw new Error(error.message);
    }
  }
}